module.exports = __webpack_public_path__ + "static/media/interview_o0.346826c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Problems/img/interview_o0.png
// module id = 261
// module chunks = 0